/**
 * Featured Products Section with Splide
 * - Slider enabled on mobile (always)
 * - Slider can be toggled on/off for desktop via settings
 * - Grid layout on desktop when slider is disabled
 */

window.initFeaturedProductsSlider = function (container) {
  const slider = container.querySelector('.featured-products__slider');

  if (!slider || typeof Splide === 'undefined') return null;

  const productCount = parseInt(container.dataset.productCount || '0');
  const enableSliderDesktop = container.dataset.enableSliderDesktop === 'true';
  const productsPerPage = parseInt(container.dataset.productsPerPage || '4');
  let splideInstance = null;

  const shouldEnableSlider = () => {
    const isTabletOrMobile = window.innerWidth < 1100;
    return isTabletOrMobile || enableSliderDesktop;
  };

  // Initialize slider (always mounted, but may be disabled)
  splideInstance = window.SplideUtils.initSplideWithControls(
    slider,
    container,
    {
      perPage: productsPerPage,
      perMove: 1,
      gap: '24px',
      arrows: false,
      pagination: false,
      rewind: true,
      drag: shouldEnableSlider(),
      breakpoints: {
        1099: { 
          perPage: 3, 
          gap: '24px',
          drag: true, // Always enabled on mobile,
        },
        767: { 
          perPage: 2, 
          gap: '16px',
          drag: true, // Always enabled on mobile,
        },
        550: { 
          perPage: 1, 
          gap: '16px',
          padding: { right: '25%'},
          drag: true, // Always enabled on mobile
        }
      },
      i18n: {
        prev: 'Previous product',
        next: 'Next product',
        first: 'Go to first product',
        last: 'Go to last product',
        slideX: 'Go to product %s',
        pageX: 'Go to page %s',
        play: 'Start autoplay',
        pause: 'Pause autoplay',
        carousel: 'Featured products carousel',
        select: 'Select a product to view',
        slide: 'product',
        slideLabel: '%s of %s',
      }
    },
    {
      customArrows: true,
      scrollbar: true,
      tabindex: true
    }
  );

  // Update slider state based on conditions
  const updateSlider = () => {
    if (!splideInstance) return;

    const shouldEnable = shouldEnableSlider();

    if (shouldEnable) {
      container.classList.add('slider-active');
      splideInstance.options.drag = true;
      splideInstance.refresh();
    } else {
      container.classList.remove('slider-active');
      splideInstance.options.drag = false;
      splideInstance.go(0);
      splideInstance.refresh();
    }
  };

  // Initial setup
  updateSlider();

  // Handle resize
  let resizeTimeout;
  const handleResize = () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(updateSlider, 250);
  };
  window.addEventListener('resize', handleResize);

  // Return destroy function for cleanup
  return {
    destroy: () => {
      window.removeEventListener('resize', handleResize);
      if (splideInstance) splideInstance.destroy();
    }
  };
};

// Initialize on page load
document.addEventListener('DOMContentLoaded', function() {
  const containers = document.querySelectorAll('[id^="FeaturedProducts-"]');
  containers.forEach(container => {
    container.sliderInstance = window.initFeaturedProductsSlider(container);
  });
});

// Setup theme editor events
if (typeof window.SplideUtils !== 'undefined') {
  window.SplideUtils.setupThemeEditorEvents(
    'FeaturedProducts-',
    '.featured-products__slider',
    (sectionElement) => {
      const container = sectionElement.querySelector('[id^="FeaturedProducts-"]');
      if (container) {
        if (container.sliderInstance?.destroy) {
          container.sliderInstance.destroy();
        }
        container.sliderInstance = window.initFeaturedProductsSlider(container);
      }
    }
  );
}
